export const TemplatePageStyle = {

    mainContainer: {
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
}